
import BaseButton from '~/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'QuoteComponent',
  comments: {
    BaseButton,
    BaseIcon,
  },
  props: {
    image: {
      type: Array,
    },
    headline: {
      type: String,
      default: null,
    },
    subheadline: {
      type: String,
      default: null,
    },
    text: {
      type: Array,
    },
    signature: {
      type: String,
    },
    readMore: {
      type: Array,
    },
    backgroundImage: {
      type: Array,
    },
    video: {
      type: Object,
    },
  },
  data() {
    return {
      isActive: false,
      showVideo: true,
    };
  },
  methods: {
    toggleMedia() {
      this.showVideo = !this.showVideo;
      this.isActive = !this.isActive;

      this.$refs.video.currentTime = this.showVideo ? 0 : this.$refs.video.currentTime;
    },
  },
};
